export default __webpack_public_path__ + "static/jazz-1267c5e62eff79d5cca0df9f4bdca1bc.png";